import { Component } from '@angular/core';

@Component({
    selector: 'help',
    templateUrl: "./help.html",
    styleUrls: ["./help.scss"],
})
export class HelpComponent {}
